import { Injectable, Pipe, PipeTransform, OnDestroy } from '@angular/core';
import { ResourceService } from './resource.service';
import { Subscription } from 'rxjs'
import { LoggingService } from '../logging.service';

@Pipe({ name: 'resource', pure: false })
@Injectable()
export class ResourcePipe implements PipeTransform, OnDestroy {

    value: string
    lastKey: string
    subscription: Subscription
    timer

    constructor(private resourceService: ResourceService, private loggingService: LoggingService) {
    }

    transform(key: string, component: string, returnKeyIfNotFound: boolean = true) {
        if (key != this.lastKey) {
            this.value = null
            this.lastKey = key
            if (this.subscription) this.subscription.unsubscribe()

            this.subscription = this.resourceService.get(key, false, component)
                .subscribe(result => {
                    if (returnKeyIfNotFound) {
                        this.value = result != null ? result : key
                        if (this.timer) clearTimeout(this.timer)
                        //it can happen result is null shortly so we insert a delay in case it changes later
                        if (result == null) this.timer = setTimeout(() => {
                            if (this.loggingService) this.loggingService.logWarn({ message: 'missing resource displayed to user: {Key} {Component}', params: [key, component] })
                            this.loggingService = null // ensure we don't log twice for same key
                        }, 1000);
                    }
                    else
                        this.value = result
                })
        }
        return this.value;
    }

    ngOnDestroy(): void {
        if (this.subscription) this.subscription.unsubscribe()
    }
}
